import { ReactNode } from 'react';
import { ColumnDef } from '#/components/UnifiedRfqs/BottomTableRow';

interface ColumnProps {
  readonly time: string;
  readonly auction: string;
  readonly product: ReactNode;
  readonly description: ReactNode;
  readonly actions: ReactNode;
  readonly status: string;
  readonly type: string;
  readonly qty: string;
  readonly price: string;
  readonly side: ReactNode;
  readonly completed: string;
  readonly canceled: string;
  readonly id: ReactNode;
  readonly account: ReactNode;
  readonly date: string;
}
export default function makeColumns({
  time,
  auction,
  product,
  account,
  actions,
  canceled,
  completed,
  date,
  description,
  id,
  price,
  qty,
  side,
  status,
  type,
}: Partial<ColumnProps> = {}): ColumnDef[] {
  return [
    {
      id: 'date',
      name: 'Date',
      children: date,
    },
    {
      id: 'time',
      name: 'Time',
      children: time,
      mobileOptions: {
        isMainRow: true,
      },
    },
    {
      id: 'auction',
      name: 'Auction',
      children: auction,
      mobileOptions: {
        isMainRow: true,
      },
    },
    {
      id: 'prod',
      name: 'Product',
      children: product,
    },
    {
      id: 'desc',
      name: 'Description',
      children: description,
      mobileOptions: {
        isMainRow: true,
      },
    },
    {
      id: 'actions',
      name: 'Actions',
      children: actions,
      mobileOptions: {
        hideLabel: true,
      },
    },
    {
      id: 'status',
      name: 'Status',
      children: status,
    },
    {
      id: 'type',
      name: 'Type',
      children: type,
    },
    {
      id: 'qty',
      name: 'Qty',
      children: qty,
    },
    {
      id: 'price',
      name: 'Price',
      children: price,
    },
    {
      id: 'side',
      name: 'Side',
      children: side,
    },
    {
      id: 'completed',
      name: 'Completed',
      children: completed,
    },
    {
      id: 'canceled',
      name: 'Canceled',
      children: canceled,
    },
    {
      id: 'id',
      name: 'Order ID',
      children: id,
    },
    {
      id: 'account',
      name: 'Account',
      children: account,
    },
  ];
}
